import React, {useContext, useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";
import {MainContext} from "../../context/MainContext";
import IEventTypes from "../../interfaces/IEventTypes";
import Select from "react-select";
import ListingEventCategories from "./EventCategories/listing";

export default function EventTypesForm() {
    const navigate = useNavigate()
    const {setPageTitle, setLoading, club} = useContext(MainContext)

    let { id} = useParams()
    const [active, setActive] = useState<boolean>(true);
    const [description, setDescription] = useState<string>('');
    const [numberOfSeries, setNumberOfSeries] = useState<number>(1);
    const [numberOfShots, setNumberOfShots] = useState<number>(1);
    const [hasHabituality, setHasHabituality] = useState(1);
    const [hasRanking, setHasRanking] = useState(0);

    const dispatchEventsObject:IEventTypes = {
        "active": active,
        "description": description,
        "has_habituality": hasHabituality,
        "has_ranking": hasRanking,
        "number_of_series": numberOfSeries,
        "number_of_shots": numberOfShots,
        "club_id": club?.id || 1,
    }

    const yesNoOptins = [
        {label: 'Sim', value: 1},
        {label: 'Não', value: 0}
    ]

    useEffect(() => {
        setPageTitle("Cadastro de Eventos")
        setLoading(true)

        const fetchData = async () => {
            if (id != undefined) {
               await api.get<IEventTypes>('/api/eventTypes/' + id).then(resposta => {
                    const eventType = resposta.data

                    setActive(eventType?.active)
                    setDescription(eventType?.description)
                    setHasHabituality(eventType?.has_habituality)
                    setHasRanking(eventType?.has_ranking)
                    setNumberOfSeries(eventType?.number_of_series)
                    setNumberOfShots(eventType?.number_of_shots)
                })
            }
        };

        fetchData().then(setLoading(false))
    },  [])

    const resgister = (evento: React.FormEvent<HTMLFormElement>) => {
        try {
            evento.preventDefault();
            setLoading(true)

            const method:'post' | 'put' = id === undefined ? 'post' : 'put';
            const url:string = id === undefined ? '/api/eventTypes' : `/api/eventTypes/${id}`;

            api[method](url, dispatchEventsObject)
                .then((result) => {
                    setLoading(false)
                    Swal.fire({
                        title: 'Sucesso!',
                        text: result.data.message,
                        icon: 'success',
                        timer: 3000
                    }).then(() => navigate("/events"));
                })
                .catch(erro => {
                    setLoading(false)
                    Swal.fire({
                        title: 'Erro!',
                        text: erro.response.data.message,
                        icon: 'error',
                    });
                });
        }catch (err: any) {
            setLoading(false)
            Swal.fire({
                title: 'Erro!',
                text: err,
                icon: 'error',
            })
        }

    }

    return (
        <>
            <form onSubmit={resgister} className="row g-3">
                <div className="col-md-12">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="active"
                               onChange={evento => setActive(evento.target.checked)} checked={active}/>
                        <label className="form-check-label" htmlFor="active">Ativo</label>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row g-3 mt-2">
                            <div className="col-md-12">
                                <label htmlFor="description" className="form-label">Descrição <i
                                    className="text-danger"> *</i></label>
                                <input type="text" className="form-control" id="description"
                                       placeholder="Descrição do evento"
                                       onChange={evento => setDescription(evento.target.value)} value={description}/>
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="has_habituality" className="form-label">Usar para Habitualidades<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    defaultValue={yesNoOptins[0]}
                                    options={yesNoOptins}
                                    value={yesNoOptins.find(option => option.value == hasHabituality)}
                                    name='has_habituality'
                                    id='has_habituality'
                                    onChange={(data: any) => {
                                        setHasHabituality(data.value)
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="has_ranking" className="form-label">Usar para Ranking<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    defaultValue={yesNoOptins[1]}
                                    options={yesNoOptins}
                                    value={yesNoOptins.find(option => option.value == hasRanking)}
                                    name='has_ranking'
                                    id='has_ranking'
                                    onChange={(data: any) => {
                                        setHasRanking(data.value)
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="has_ranking" className="form-label">Quantidade series<i
                                    className="text-danger"> *</i></label>
                                <input type="number" className="form-control" id="description"
                                       placeholder="Descrição do evento"
                                       onChange={evento => setNumberOfSeries(parseInt(evento.target.value))} value={numberOfSeries}/>
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="has_ranking" className="form-label">Quantidade de disparos por serie<i
                                    className="text-danger"> *</i></label>
                                <input type="text" className="form-control" id="description"
                                       placeholder="Descrição do evento"
                                       onChange={evento => setNumberOfShots(parseInt(evento.target.value))} value={numberOfShots}/>
                            </div>

                            <div>
                                <button type="submit" className="btn btn-success me-2">Salvar</button>
                                <Link to={"/events"} className="btn btn-danger">Voltar</Link>
                            </div>
                        </div>
                    </div>
                </div>

                {id &&
                    <ListingEventCategories eventTypeId={id}/>
                }
            </form>
        </>
    );
}

